import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { removeFeedback } from '../../../Redux/Slices/Common/Feedback/FeedbackSlice';
import './FeedbackToast.css';

const ICONS = {
    success: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    error: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    warning: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
    ),
    info: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
    ),
};

const FeedbackToast = ({ item }) => {
    const dispatch = useDispatch();
    const [phase, setPhase] = useState('enter');
    const [progress, setProgress] = useState(100);

    const handleClose = useCallback(() => {
        setPhase('exit');
        setTimeout(() => {
            dispatch(removeFeedback(item.id));
        }, 500); // Matched to CSS transition
    }, [dispatch, item.id]);

    useEffect(() => {
        const start = Date.now();
        const duration = item.duration || 4000;
        
        const interval = setInterval(() => {
            const elapsed = Date.now() - start;
            const remaining = Math.max(0, 100 - (elapsed / duration) * 100);
            setProgress(remaining);
            
            if (remaining <= 0) {
                clearInterval(interval);
                handleClose();
            }
        }, 20);

        const t = setTimeout(() => setPhase('visible'), 50);

        return () => {
            clearInterval(interval);
            clearTimeout(t);
        };
    }, [item.duration, handleClose]);

    return (
        <div className={`bz-feedback-toast bz-feedback-toast--${item.type} bz-feedback-toast--${phase}`} role="alert">
            <div className="bz-feedback-toast__icon">
                {ICONS[item.type] || ICONS.info}
            </div>
            <div className="bz-feedback-toast__content">
                <p className="bz-feedback-toast__message">{item.message}</p>
            </div>
            <button className="bz-feedback-toast__close" onClick={handleClose} aria-label="Close">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
            <div className="bz-feedback-toast__progress">
                <div className="bz-feedback-toast__progress-bar" style={{ width: `${progress}%` }} />
            </div>
        </div>
    );
};

export const FeedbackToastContainer = ({ queue }) => {
    if (!queue || queue.length === 0) return null;

    return (
        <div className="bz-feedback-container">
            {queue.map((item) => (
                <FeedbackToast key={item.id} item={item} />
            ))}
        </div>
    );
};

export default FeedbackToast;
